//Components
import { NavbarContainer } from "./Navbar.style";
//Images
import logo from "../../../assets/logo/IMG-20240204-WA0003.jpg";
import wpIcon from "../../../assets/logo/wpIcon.png";
import arrowIcon from "../../../assets/logo/arrowIcon.png";
import { flags } from "./Flags";
//Packages
import { RefObject, useEffect, useRef, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { SelectedLanguage } from "../stateTypes";
import { keywords, metaTags } from "../../../variables";
import { useNavigate } from "react-router-dom";

interface NavbarProps {
  isAtTop: boolean;
  scrollToItem: (itemName: string) => void;
  navbarRef: RefObject<HTMLDivElement>;
  setSelectedLanguage: React.Dispatch<React.SetStateAction<SelectedLanguage>>; 
  selectedLanguage: SelectedLanguage; 
}

export const Navbar = ({
  isAtTop,
  scrollToItem,
  navbarRef,
  setSelectedLanguage,
  selectedLanguage,
}: NavbarProps) => {

  const [isArrowOpen, setIsArrowOpen] = useState<boolean>(false);

  const navigate = useNavigate();

  const useSize = () => {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const windowSizeHandler = () => {
        setWindowWidth(window.innerWidth);
      };
      window.addEventListener("resize", windowSizeHandler);
      return () => {
        window.removeEventListener("resize", windowSizeHandler);
      };
    }, []);

    return windowWidth;

  };

  const windowSize = useSize();

  return (
    <NavbarContainer ref={navbarRef} className={`navbar`}>
      <Helmet>
        <title>{metaTags[selectedLanguage].title}</title>
        <meta name="description" content={metaTags[selectedLanguage].description} />
        <meta name="robots" content={metaTags[selectedLanguage].robots} />
        <meta name="og:title" content={metaTags[selectedLanguage].og.title} />
        <meta name="og:description" content={metaTags[selectedLanguage].og.description} />
      </Helmet> 
      <div className="navBAR">
        <div className="logo-container">
          <div className="inner-logo-container">
            <img src={logo} alt={"logo" + keywords[selectedLanguage][0]} />
            <div className="title-container">
              <h2>BODYGUARD</h2>
              <h2>SERVICES TURKEY</h2>
            </div>
          </div>
        </div>
        <div className="list-container-2">
          <div className="inner-list-container">
            <ul>
              <li>
                <h3
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Home Page
                </h3>
              </li>
              <li>
                <h3 onClick={() => scrollToItem("aboutUs")}>About Us</h3>
              </li>
              <li>
                <h3 onClick={() => scrollToItem("services")}>Services</h3>
              </li>
              <li>
                <h3 onClick={() => scrollToItem("references")}>References</h3>
              </li>
              <li className="wpIcon">
                <div>
                  <h3 onClick={() => scrollToItem("footer")}>Contact</h3>
                  <a href="tel:+905438818113">
                    <p>+905438818113</p>
                  </a>
                </div>
                <div className="rightIcons">
                  <div className="wpDiv">
                    <a href="https://wa.me/905438818113">
                      <img src={wpIcon} alt={"whatshapp icon" + keywords[selectedLanguage][1]} />
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        {windowSize > 1200 && (
          <div className="flag-container">
            <img
              onClick={() => {
                setSelectedLanguage("english");
                navigate("english");
              }}
              src={flags.UKingdomFlag}
              className={`${selectedLanguage === "english" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("turkish");
                navigate("turkish");
              }}
              src={flags.TurkeyFlag}
              className={`${selectedLanguage === "turkish" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("german");
                navigate("german");
              }}
              src={flags.GermanyFlag}
              className={`${selectedLanguage === "german" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("russian");
                navigate("russian");
              }}
              src={flags.RussianFlag}
              className={`${selectedLanguage === "russian" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("arabic");
                navigate("arabic");
              }}
              src={flags.SaudiArabicFlag}
              className={`${selectedLanguage === "arabic" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("ukraine");
                navigate("ukraine");
              }}
              src={flags.UkraineFlag}
              className={`${selectedLanguage === "ukraine" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("italian");
                navigate("italian");
              }}
              src={flags.ItalianFlag}
              className={`${selectedLanguage === "italian" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("persian");
                navigate("persian");
              }}
              src={flags.IranFlag}
              className={`${selectedLanguage === "persian" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("chinese");
                navigate("chinese");
              }}
              src={flags.chineseFlag}
              className={`${selectedLanguage === "chinese" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("french");
                navigate("french");
              }}
              src={flags.frenchFlag}
              className={`${selectedLanguage === "french" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("greece");
                navigate("greece");
              }}
              src={flags.greeceFlag}
              className={`${selectedLanguage === "greece" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("japon");
                navigate("japon");
              }}
              src={flags.japonFlag}
              className={`${selectedLanguage === "japon" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("korean");
                navigate("korean");
              }}
              src={flags.koreanFlag}
              className={`${selectedLanguage === "korean" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("pakistan");
                navigate("pakistan");
              }}
              src={flags.pakistanFlag}
              className={`${selectedLanguage === "pakistan" ? "active" : ""}`}
            />
            <img
              onClick={() => {
                setSelectedLanguage("romanian");
                navigate("romanian");
              }}
              src={flags.romanianFlag}
              className={`${selectedLanguage === "romanian" ? "active" : ""}`}
            />
          </div>
        )}
      </div>
      {windowSize < 1200 && (
        <div className="flagW">
          <img
            onClick={() => {
              setSelectedLanguage("english");
              navigate("english");
            }}
            src={flags.UKingdomFlag}
            className={`${selectedLanguage === "english" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("turkish");
              navigate("turkish");
            }}
            src={flags.TurkeyFlag}
            className={`${selectedLanguage === "turkish" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("german");
              navigate("german");
            }}
            src={flags.GermanyFlag}
            className={`${selectedLanguage === "german" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("russian");
              navigate("russian");
            }}
            src={flags.RussianFlag}
            className={`${selectedLanguage === "russian" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("arabic");
              navigate("arabic");
            }}
            src={flags.SaudiArabicFlag}
            className={`${selectedLanguage === "arabic" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("ukraine");
              navigate("ukraine");
            }}
            src={flags.UkraineFlag}
            className={`${selectedLanguage === "ukraine" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("italian");
              navigate("italian");
            }}
            src={flags.ItalianFlag}
            className={`${selectedLanguage === "italian" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("persian");
              navigate("persian");
            }}
            src={flags.IranFlag}
            className={`${selectedLanguage === "persian" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("chinese");
              navigate("chinese");
            }}
            src={flags.chineseFlag}
            className={`${selectedLanguage === "chinese" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("french");
              navigate("french");
            }}
            src={flags.frenchFlag}
            className={`${selectedLanguage === "french" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("greece");
              navigate("greece");
            }}
            src={flags.greeceFlag}
            className={`${selectedLanguage === "greece" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("japon");
              navigate("japon");
            }}
            src={flags.japonFlag}
            className={`${selectedLanguage === "japon" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("korean");
              navigate("korean");
            }}
            src={flags.koreanFlag}
            className={`${selectedLanguage === "korean" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("pakistan");
              navigate("pakistan");
            }}
            src={flags.pakistanFlag}
            className={`${selectedLanguage === "pakistan" ? "active" : ""}`}
          />
          <img
            onClick={() => {
              setSelectedLanguage("romanian");
              navigate("romanian");
            }}
            src={flags.romanianFlag}
            className={`${selectedLanguage === "romanian" ? "active" : ""}`}
          />
        </div>
      )}
    </NavbarContainer>
  );

};
